// extracted by mini-css-extract-plugin
module.exports = {"content":"SisSyncTab_content__51ozI"};